import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import Reveal from '../components/ui/Reveal';
import Button from '../components/ui/Button';
import caseStudies from '../data/caseStudies.json';
import './CaseStudyPage.css';

const CaseStudyPage = () => {
  const { slug } = useParams();
  const cs = caseStudies.find((c) => c.slug === slug);
  const others = caseStudies.filter((c) => c.slug !== slug).slice(0, 2);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!cs) {
    return (
      <>
        <Navbar />
        <div className="cs-notfound tra-container">
          <h1>Case study not found</h1>
          <Button to="/#work" variant="primary">Back to Work</Button>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <>
        <title>{cs.brand} — Case Study | ThirdRail Avenue</title>
        <meta name="description" content={cs.summary} />
      </>

      <Navbar />

      <article className="cs" id="main-content" style={{ '--cs-accent': cs.accent }}>
        <header className="cs__hero">
          <div className="cs__hero-bg">
            <img src={process.env.PUBLIC_URL + cs.image} alt={cs.brand} />
            <div className="cs__hero-scrim" />
          </div>
          <div className="cs__hero-content tra-container">
            <Link to="/#work" className="cs__back">← All Work</Link>
            <span className="cs__category">{cs.category}</span>
            <h1 className="cs__title">{cs.title}</h1>
            <p className="cs__summary">{cs.summary}</p>
            <div className="cs__tags">
              {cs.tags.map((t) => (
                <span key={t} className="cs__tag">{t}</span>
              ))}
            </div>
          </div>
        </header>

        <section className="cs__results-band">
          <div className="tra-container cs__results-grid">
            {cs.results.map((r) => (
              <Reveal className="cs__result" key={r.label}>
                <span className="cs__result-value">{r.value}</span>
                <span className="cs__result-label">{r.label}</span>
              </Reveal>
            ))}
          </div>
        </section>

        <section className="cs__body tra-container">
          <Reveal className="cs__block">
            <span className="tra-eyebrow">The Challenge</span>
            <p>{cs.challenge}</p>
          </Reveal>
          <Reveal className="cs__block" delay={0.1}>
            <span className="tra-eyebrow">Our Approach</span>
            <p>{cs.approach}</p>
          </Reveal>
        </section>

        <section className="cs__cta tra-container">
          <Reveal className="cs__cta-inner">
            <h2>Want a campaign like this?</h2>
            <Button to="/#contact" variant="primary" size="lg" arrow>Work With Us</Button>
          </Reveal>
        </section>

        {others.length > 0 && (
          <section className="cs__more tra-container">
            <h3 className="cs__more-title">More work</h3>
            <div className="cs__more-grid">
              {others.map((o) => (
                <Link key={o.slug} to={`/work/${o.slug}`} className="cs__more-card">
                  <img src={process.env.PUBLIC_URL + o.image} alt={o.brand} loading="lazy" />
                  <div className="cs__more-info">
                    <span className="cs__more-brand">{o.brand}</span>
                    <h4>{o.title}</h4>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        )}
      </article>

      <Footer />
    </>
  );
};

export default CaseStudyPage;
